import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { locationTypeApiClient } from '@peritasai/data-access';
import type { LocationTypeResponseDto } from '@peritasai/types';

export const locationTypeKeys = {
  all: ['location-types'] as const,
  lists: () => [...locationTypeKeys.all, 'list'] as const,
  list: () => [...locationTypeKeys.lists(), {}] as const,
} as const;

export function useLocationTypes(): UseQueryResult<LocationTypeResponseDto[]> {
  return useQuery({
    queryKey: locationTypeKeys.list(),
    queryFn: () => locationTypeApiClient.getLocationTypes(),
    staleTime: 5 * 60 * 1000,
  });
}
